import withAuthGuard from '@hocs/withAuthGuard';
import withVerificationGuard from '@hocs/withVerificationGuard';
import { flowRight } from 'lodash';

import LeveragePage from './LeveragePage';

export default flowRight(withVerificationGuard, withAuthGuard())(LeveragePage);
